import { render, staticRenderFns } from "./rodape.vue?vue&type=template&id=19f4380c&"
import script from "./rodape.vue?vue&type=script&lang=js&"
export * from "./rodape.vue?vue&type=script&lang=js&"
import style0 from "./rodape.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports